import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["direction", "aria-label"];
import React from 'react';
import { TableSortIconElement } from "./TableSortIcon";

function getIconAriaLabel(direction) {
  return direction === 'up' ? 'Sort column (ascending)' : 'Sort column (descending)';
}

export var TableSortIcon = function TableSortIcon(_ref) {
  var _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'down' : _ref$direction,
      ariaLabel = _ref['aria-label'],
      props = _objectWithoutProperties(_ref, _excluded);

  var iconAriaLabel = ariaLabel ? ariaLabel : getIconAriaLabel(direction);
  return /*#__PURE__*/React.createElement(TableSortIconElement, Object.assign({
    direction: direction,
    "aria-label": iconAriaLabel
  }, props));
};
/**
* **TableSortIcon** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/TableSortIcon) | [Storybook](https://encore-web.spotify.net/?path=/docs/components-table-tablesorticon--down-direction) | [Encore](https://encore.spotify.net/web/components/table?format=figma-figma#header-cell) | [Figma](https://www.figma.com/file/bnQXqGkLeiTlbk8JXGDcsX/Encore-Web---Light-Theme-Toolkit?node-id=848:2648) |
*
* The TableSortIcon renders a chevron icon in the table's header row to enable sorting. It's used in conjunction with the TableHeaderCell
*
* @example
* () => (
*  <Table>
*    <thead>
*      <TableRow>
*        <TableHeaderCell active>
*          Descending
*          <TableSortIcon />
*        </TableHeaderCell>
*        <TableHeaderCell active>
*          Descending
*          <TableSortIcon />
*        </TableHeaderCell>
*        <TableHeaderCell align="right" active>
*          <TableSortIcon />
*          Descending, right-aligned
*        </TableHeaderCell>
*      </TableRow>
*    </thead>
*  </Table>
*);
*
*/

export default TableSortIcon;